import { createAppSelector } from 'store/hooks';

export const focusTemplateActionsSelector = createAppSelector(
  [
    (state) => state.focusMode.currentViewedFocusTemplate,
    (state) => state.focusMode.userInstalledFocusTemplates,
    (state) => state.user.details?.id,
    (state) => state.user.isUserAdmin
  ],
  (
    currentViewedFocusTemplate,
    userInstalledFocusTemplates,
    userId,
    isUserAdmin
  ) => {
    return {
      currentViewedFocusTemplate,
      userInstalledFocusTemplates,
      userId,
      isUserAdmin
    };
  }
);

export const marketplaceFocusTemplatesTabPanelSelector = createAppSelector(
  [
    (state) => state.focusMode.isMarketFocusTemplatesFetching,
    (state) => state.setting.language
  ],
  (isMarketFocusTemplatesFetching, language) => {
    return {
      isMarketFocusTemplatesFetching,
      language
    };
  }
);

export const focusTemplateLandingPageSelector = createAppSelector(
  [
    (state) => state.focusMode.isSharedFocusTemplateFetching,
    (state) => state.focusMode.sharedFocusTemplate,
    (state) => state.focusMode.currentViewedFocusTemplate,
    (state) => state.focusMode.userInstalledFocusTemplates,
    (state) => state.setting.isTokenAddedToInterceptor
  ],
  (
    isSharedFocusTemplateFetching,
    sharedFocusTemplate,
    currentViewedFocusTemplate,
    userInstalledFocusTemplates,
    isTokenAddedToInterceptor
  ) => {
    return {
      isSharedFocusTemplateFetching,
      sharedFocusTemplate,
      currentViewedFocusTemplate,
      userInstalledFocusTemplates,
      isTokenAddedToInterceptor
    };
  }
);

export const listOfFocusTemplatesSelector = createAppSelector(
  [(state) => state.focusMode.marketplaceApprovedFocusTemplates],
  (marketplaceApprovedFocusTemplates) => {
    return marketplaceApprovedFocusTemplates;
  }
);

export const packAndFocusModeInfoSelector = createAppSelector(
  [
    (state) => state.setting.currentSettings,
    (state) => state.setting.tabs,
    (state) => state.setting.activeTabIndex,
    (state) => state.focusMode.currentViewedFocusTemplate,
    (state) => state.user.isUserAdmin
  ],
  (
    currentSettings,
    tabs,
    activeTabIndex,
    currentViewedFocusTemplate,
    isUserAdmin
  ) => {
    return {
      currentSettings,
      tabs,
      activeTabIndex,
      currentViewedFocusTemplate,
      isUserAdmin
    };
  }
);
